import {
  DEFAULT_GRID_COLUMNS,
  DEFAULT_GRID_ROWS,
} from '../components/PageConfigProvider/constants';
import type { TabContent } from '../components/PageConfigProvider/page-reducer';
import {
  type Page,
  PageType,
  RevelioPageId,
} from '../components/PageConfigProvider/types';
import type { MetricValues } from '../components/PageConfigProvider/types/metric';
import { FilterId } from '../filters/types/filters';

const companyPostingsMetrics: MetricValues[] = [
  'postings_active',
  'postings_new',
  'postings_removed',
];

const companyPostingsItems: TabContent['items'] = [
  {
    position: { x: 0, width: 16, y: 0, height: 12 },
    id: 'company-postings-posting-salary',
    title: 'Salary',
    info: {
      text: 'The average salary listed on job postings.',
    },
    plot: {
      defaultMetricOptions: ['posting_salary'],
      chartType: 'line',
    },
  },
  {
    position: { x: 16, width: 16, y: 0, height: 12 },
    id: 'company-postings-time-to-fill',
    title: 'Time to Fill',
    info: {
      text: 'The average time it takes to fill a job posting.',
    },
    plot: {
      defaultMetricOptions: ['time_to_fill'],
      chartType: 'line',
    },
  },
  {
    position: { x: 0, width: 32, y: 12, height: 24 },
    id: 'company-postings-postings-volume',
    title: 'Postings',
    info: {
      text: 'The number of active job postings, new job postings, and removed job postings.',
    },
    plot: {
      defaultMetricOptions: companyPostingsMetrics,
      chartType: 'volume',
    },
  },
  {
    position: { x: 32, width: 16, y: 0, height: 36 },
    id: 'company-postings-active-postings-role',
    title: 'Top Roles',
    info: {
      text: 'The top 15 roles in terms of number of added postings over the selected time range.',
    },
    plot: {
      defaultMetricOptions: ['postings_active'],
      secondaryDimension: 'role',
      chartType: 'grouped-bar',
    },
  },
];

const companyPostingsTab: TabContent = {
  id: 'company-postings',
  items: companyPostingsItems,
  primaryFilter: {
    id: FilterId.COMPANY,
    selectionLimit: 6,
    selectionDefault: 1,
    tagColors: true,
  },
  grid: { rows: DEFAULT_GRID_ROWS, columns: DEFAULT_GRID_COLUMNS },
  secondaryFilters: [
    FilterId.DATE_RANGE,
    FilterId.ROLE,
    FilterId.GEOGRAPHY,
    FilterId.SENIORITY,
    FilterId.SKILL,
    FilterId.CUSTOM_SKILL,
    FilterId.TITLE,
    FilterId.POSTINGS_SOURCE,
    FilterId.METRIC_MODE,
  ].map((id) => ({ id })),
};

export const companyPostings: Page = {
  type: PageType.REVELIO_PUBLIC,
  id: RevelioPageId.COMPANY_POSTINGS,
  revelioPageId: RevelioPageId.COMPANY_POSTINGS,
  name: 'Job Postings',
  owner: { id: 'revelio-labs', username: 'revelio-labs' },
  tabs: [
    {
      id: 'company-postings',
      label: 'Job Postings',
      tabContent: companyPostingsTab,
      isActive: true,
    },
  ],
};
